import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { updateCart } from "../../../../v1/actions/user"
import { useTranslation } from "react-i18next"
import { getUpdatedCart, isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"
import { Divider, Form, FormField, Header, Message } from "semantic-ui-react"
import { AccordionTitle, AccordionContent, Accordion, Icon } from "semantic-ui-react"
import ServiceTile from "./ServiceTile"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import { isEbayUser } from "../../../../v1/helpers/affiliationHelpers"
import Notifications from "../../../../v1/components/Notifications"
import store from "../../../../shared_component/utils/configureStore"
import { CA } from "../../../../v1/constants/states"

const ReviewServices = (props) => {
  const [pricedServices, setPricedServices] = useState([])
  const [noPricedServices, setNoPricedServices] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [activeIndex, setActiveIndex] = useState(-1)
  const { cart, user, order, customerNote, handleCustomerNote, history, isCart } = props
  const { t } = useTranslation("serviceRequest")
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)
  const formatAmount = (amount) => `$${Number(amount || 0).toFixed(2)}`
  const upfrontSubtotal = cart?.services_total || 0

  useEffect(() => {
    getServices()
  }, [cart])

  const getServices = () => {
    let updatedCartData = getUpdatedCart(user, order, props)
    const orderServices = updatedCartData.cart.order_services
    if (orderServices !== null) {
      const _pricedServices = orderServices?.filter(
        (service) => !!service?.price_estimate?.shop_price_estimate
      )
      const _noPricedServices = orderServices?.filter(
        (service) => !!!service?.price_estimate?.shop_price_estimate
      )

      if (isEbayTireOrder(cart ?? order)) {
        _pricedServices.push(..._noPricedServices)
      }

      setPricedServices(_pricedServices)
      !isEbayTireOrder(cart ?? order) && setNoPricedServices(_noPricedServices)
    }
  }

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex)
  }

  const removeService = async (os, event) => {
    if (cart?.order_services?.length == 1) {
      store.dispatch(
        Notifications.error({
          title: t("Error"),
          message: "At least one service is required in the cart.",
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      return
    }
    setIsLoading(true)
    const { activeVehicle, isCart, order } = props
    let opts = {
      isOrder: !isCart && order && !order.is_tire_order,
      orderId: order && order.id,
      successCallback: async () => {
        trackFirebaseAnalytics({
          event: gaJSON.service_selected,
          params: {
            [gaJSON.service_name]: os.name,
            [gaJSON.service_type]: !os.position ? os.name : `${os.name} - ${os.position}`,
            [gaJSON.from_where]: window.location.hash,
            [gaJSON.vehicle_name]: activeVehicle
              ? `${activeVehicle?.year || ""} ${activeVehicle?.make?.toUpperCase() || ""} ${
                  activeVehicle?.model?.toUpperCase() || ""
                }`
              : null
          }
        })
      }
    }
    try {
      await props.updateCart(
        [
          {
            service_definition_id: os.service_id || os.id || os.service_definition_id,
            event: event,
            prepaid: os.prepaid,
            position: os.position
          }
        ],
        props.cart.vehicle_id,
        undefined,
        undefined,
        opts
      )
      getServices()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      return { error: error.message }
    }
  }

  return (
    <div className="review-services">
      <div className="review-services-title">
        <Header as="h3">{t("serviceRequested")}</Header>
        {!isEbayTireCart && !isOilChangeService && isCart && (
          <p
            className="link-text"
            onClick={() => {
              history.push({
                pathname: routerPaths.selectService,
                state: { fromReviewRequest: true }
              })
            }}
          >
            {t("addMoreServices")}
          </p>
        )}
      </div>
      {cart.order_services.length == 0 && (
        <Message size="mini" negative>
          {t("pleaseAddAtLeast")}
        </Message>
      )}
      {isLoading && <ShimmerServiceCard count={7} />}
      {!isLoading && user.country !== CA && (
        <>
          <Accordion className="services-accordion">
            {pricedServices.length > 0 && (
              <>
                <div>
                  <AccordionTitle active={activeIndex === 0} index={0} onClick={handleClick}>
                    <div className="accordion-title">
                      <div>
                        <Icon
                          className="accordion_icon"
                          name={activeIndex === 0 ? "chevron up" : "chevron right"}
                        />
                        <b>
                          {t("upfrontPricing")} ({pricedServices.length})
                        </b>
                      </div>
                    </div>
                  </AccordionTitle>
                  <AccordionContent active={activeIndex === 0}>
                    <Divider className="service-row-divider" />
                    {pricedServices &&
                      pricedServices.map((service) => (
                        <ServiceTile
                          key={service.id}
                          service={service}
                          handleService={removeService}
                          cart={cart}
                        />
                      ))}
                    {upfrontSubtotal > 0 && (
                      <>
                        <Divider className="service-row-divider" />
                        <div className="row-space-between upfront-subtotal-row">
                          <div>{t("subtotal")}</div>
                          <div>{formatAmount(upfrontSubtotal)}</div>
                        </div>
                      </>
                    )}
                  </AccordionContent>
                  <Divider className="divider-margin" />
                </div>
              </>
            )}

            {noPricedServices.length > 0 && (
              <div>
                <AccordionTitle active={activeIndex === 1} index={1} onClick={handleClick}>
                  <Icon
                    className="accordion_icon"
                    name={activeIndex === 1 ? "chevron up" : "chevron right"}
                  />
                  <b>
                    {t("pricedAtShop")} ({noPricedServices.length})
                  </b>
                </AccordionTitle>
                <AccordionContent active={activeIndex === 1}>
                  {noPricedServices.length > 0 && (
                    <div className="common-services">
                      {noPricedServices &&
                        noPricedServices.map((service, index) => (
                          <>
                            <ServiceTile
                              key={service.id}
                              service={service}
                              handleService={removeService}
                            />
                          </>
                        ))}
                    </div>
                  )}
                </AccordionContent>
                <Divider className="divider-margin" />
              </div>
            )}
            <div>
              <AccordionTitle active={activeIndex === 2} index={2} onClick={handleClick}>
                <Icon
                  className="accordion_icon"
                  name={activeIndex === 2 ? "chevron up" : "chevron right"}
                />
                <b>{t("addNotes")}</b>
              </AccordionTitle>
              <AccordionContent active={activeIndex === 2}>
                <p>{t("letUsKnow")}</p>
                <Form>
                  <FormField>
                    <textarea
                      minLength={100}
                      rows={5}
                      placeholder={t("hearingASquealingNoise")}
                      value={customerNote}
                      onChange={handleCustomerNote}
                      style={{ width: "auto" }}
                    />
                    <div style={{ textAlign: "right" }}>
                      {customerNote.length}
                      {t("minCharacters")}
                    </div>
                  </FormField>
                </Form>
              </AccordionContent>
            </div>
          </Accordion>
        </>
      )}
      {!isLoading && user.country === CA && noPricedServices.length > 0 && (
        <div className="common-services">
          {noPricedServices &&
            noPricedServices.map((service) => (
              <>
                <ServiceTile key={service.id} service={service} handleService={removeService} />
              </>
            ))}
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }
  return {
    cart: cart,
    user: user,
    activeVehicle,
    order,
    isCart: updatedCartData.isCart
  }
}

export default withRouter(connect(mapStateToProps, { updateCart })(ReviewServices))
